import './streakDays.css';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';


const StreakDays = ({
  streakDaysForDisplay,
  handleDayClickstrike,
  dailyLessons
}) => {
  const progressPercent = Math.min((dailyLessons / 3) * 100, 100);
  const streakActive = dailyLessons >= 3;

  return (
    <div className="streak-card">
      {/* HEADER */}
      <div className="streak-header">
        <div className="streak-main">
          <span className="streak-number">{dailyLessons}</span>

        <FontAwesomeIcon
  icon={faBolt}
  className={`streak-bolt ${streakActive ? 'active' : ''}`}
/>


       
        </div>

        <p className="streak-text">
          {streakActive
            ? 'Energia maxima. Seria este pastrata.'
            : `Incarca-ti energia zilnica. Mai ai ${3 - dailyLessons} lectii.`}
        </p>
      </div>

      {/* ENERGY BAR – RAMANE */}
      <div className="energy-wrapper">
        <div className="energy-bar">
          <div
            className="energy-fill"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>

      {/* DAYS */}
      <div className="streak-days">
        {streakDaysForDisplay.map((day, i) => (
          <div key={i} className="streak-day-wrapper">
            <div
              className={`streak-day-dot 
                ${day.inStreak ? 'completed' : ''} 
                ${day.today ? 'today' : ''}`}
              onClick={() =>
                handleDayClickstrike(day, day.inStreak)
              }
            />
            <span className="streak-day-label">{day.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StreakDays;
